import React, { Component } from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Link } from 'plurall-ui'

import styles from './LayoutBox.module.css'

//MOSTRAR ICONE+NOME ALTERNATIVO
//PODER MOSTRAR ELES INDEPENDENTE
//O LINK FICA NELE
class LayoutBox extends Component {
  state = {
    semiClosedModeOpened: false,
    semiClosedModeContentOriginalHeight: 0,
    semiClosedModeContentHeight: 0,
    semiClosedModeContentSemiClosedHeight: 200,
    contentHtmlId: 'layoutbox-content-' + new Date().getMilliseconds(),
    semiClosedModeContentOverflow: 'hidden',
    closedModeDisplay: 'none',
  }

  semiClosedModeAnimationFactor = () => {
    return 10
  }

  showBox = () => {
    this.setState({ closedModeDisplay: 'block' })
  }

  hideBox = () => {
    this.setState({ closedModeDisplay: 'none' })
  }

  showMore = () => {
    this.setState({ semiClosedModeOpened: true })
    this.semiClosedModeIntervalID = setInterval(() => this.showMoreAnimation(), 1)
  }

  showMoreAnimation = () => {
    if (this.state.semiClosedModeContentHeight >= this.state.semiClosedModeContentOriginalHeight) {
      const bottomSpace = 30
      this.setState({
        semiClosedModeContentHeight: this.state.semiClosedModeContentHeight + bottomSpace,
        semiClosedModeContentOverflow: 'visible',
      })
      clearInterval(this.semiClosedModeIntervalID)
      return
    }

    this.setState({
      semiClosedModeContentHeight:
        this.state.semiClosedModeContentHeight + this.semiClosedModeAnimationFactor(),
    })
  }

  showLess = () => {
    this.setState({ semiClosedModeOpened: false })

    this.semiClosedModeIntervalID = setInterval(() => this.showLessAnimation(), 1)
  }

  showLessAnimation = () => {
    if (
      this.state.semiClosedModeContentHeight === this.state.semiClosedModeContentSemiClosedHeight
    ) {
      clearInterval(this.semiClosedModeIntervalID)
      return
    }

    let height = this.state.semiClosedModeContentHeight - this.semiClosedModeAnimationFactor()
    if (height < this.state.semiClosedModeContentSemiClosedHeight) {
      height = this.state.semiClosedModeContentSemiClosedHeight
    }

    this.setState({
      semiClosedModeContentHeight: height,
      semiClosedModeContentOverflow: 'hidden',
    })
  }

  semiClosedModeEnabled = () => {
    return this.props.presentationMode === 'read_more'
  }

  openedModeEnabled = () => {
    return this.props.presentationMode === 'open'
  }

  closedModeEnabled = () => {
    return this.props.presentationMode === 'closed'
  }

  componentDidMount = () => {
    if (this.state.semiClosedModeContentOriginalHeight === 0) {
      setTimeout(() => {
        const content = document.getElementById(this.state.contentHtmlId)
        this.setState({
          semiClosedModeContentOriginalHeight: content.clientHeight,
          semiClosedModeContentHeight: this.state.semiClosedModeContentSemiClosedHeight,
        })
      }, 500)
    }
  }

  renderClosedModeLink = () => {
    const { alternateTitle, iconImageUrl } = this.props

    return (
      <div className={styles.closeModeLink}>
        <Link href={null} onClick={this.showBox}>
          {iconImageUrl && <img src={iconImageUrl} alt='icone' />}
          <span dangerouslySetInnerHTML={{ __html: alternateTitle }} />
        </Link>
      </div>
    )
  }

  render = () => {
    const inlineStyle = {}

    const {
      borderEnabled,
      backgroundColorEnabled,
      fontColorEnabled,
      headerImageEnabled,
      footerImageEnabled,
      borderColor,
      backgroundColor,
      fontColor,
      headerImageUrl,
      footerImageUrl,
    } = this.props

    if (borderEnabled) {
      inlineStyle.borderColor = borderColor
      inlineStyle.borderStyle = 'solid'
      inlineStyle.borderWidth = '3px'
    }

    if (backgroundColorEnabled) {
      inlineStyle.backgroundColor = backgroundColor
    }

    if (fontColorEnabled) {
      inlineStyle.color = fontColor
    }

    if (this.closedModeEnabled()) {
      inlineStyle.display = this.state.closedModeDisplay
    }

    const contentInlineStyle = {}
    if (this.semiClosedModeEnabled()) {
      contentInlineStyle.overflow = this.state.semiClosedModeContentOverflow
      if (this.state.semiClosedModeContentHeight > 0) {
        contentInlineStyle.height = `${this.state.semiClosedModeContentHeight}px`
      }
    }

    const readMoreInlineStyle = {
      backgroundImage: `linear-gradient(to bottom, transparent, ${backgroundColor})`,
    }
    const readLessInlineStyle = {
      display: 'none',
    }

    if (this.semiClosedModeEnabled()) {
      if (this.state.semiClosedModeOpened) {
        readMoreInlineStyle.display = 'none'
        readLessInlineStyle.display = 'block'
      }
    }

    return (
      <>
        {this.closedModeEnabled() &&
          this.state.closedModeDisplay === 'none' &&
          this.renderClosedModeLink()}
        <div style={inlineStyle} className={`${styles.box} layout-box`}>
          {headerImageEnabled && (
            <img
              src={headerImageUrl}
              alt='banner do topo'
              className={`${styles.headerImage} ${borderEnabled ? styles.headerImageRounded : ''}`}
            />
          )}
          <div id={this.state.contentHtmlId} className={styles.content} style={contentInlineStyle}>
            {this.props.children}
            {this.semiClosedModeEnabled() &&
              (this.state.semiClosedModeOpened ? (
                <p className={styles.readLess} style={readLessInlineStyle}>
                  <Link href={null} onClick={this.showLess}>
                    [ - ] Mostrar menos
                  </Link>
                </p>
              ) : (
                <p className={styles.readMore} style={readMoreInlineStyle}>
                  <Link href={null} onClick={this.showMore}>
                    [ + ] Mostrar mais
                  </Link>
                </p>
              ))}
            {this.closedModeEnabled() && (
              <p className={styles.hideBox}>
                <Link href={null} onClick={this.hideBox}>
                  [ x ] Fechar
                </Link>
              </p>
            )}
          </div>
          {footerImageEnabled && (
            <img
              src={footerImageUrl}
              alt='banner do rodape'
              className={`${styles.footerImage} ${borderEnabled ? styles.footerImageRounded : ''}`}
            />
          )}
        </div>
      </>
    )
  }
}

LayoutBox.propTypes = {
  children: PropTypes.node.isRequired,
  borderEnabled: PropTypes.bool,
  backgroundColorEnabled: PropTypes.bool,
  fontColorEnabled: PropTypes.bool,
  headerImageEnabled: PropTypes.bool,
  footerImageEnabled: PropTypes.bool,
}

const fragments = {
  paragraph: gql`
    fragment BoxParagraphFragment on ParagraphLayoutBox {
      id
      affect: fieldLayoutBoxAffect
      typeOf: fieldBoxType {
        entity {
          ... on TaxonomyTermBoxTypes {
            name
            fieldAlternateTitle {
              value
            }
            fieldBorderBoolean
            fieldFontBoolean
            fieldBackgroundBoolean
            fieldHeaderImageBoolean
            fieldFooterImageBoolean
            fieldBoxPresentation
            fieldBorderColor {
              color
            }
            fieldBackgroundColor {
              color
            }
            fieldFontColor {
              color
            }
            fieldHeaderImage {
              entity {
                ... on MediaImage {
                  image: thumbnail {
                    url
                  }
                }
              }
            }
            fieldFooterImage {
              entity {
                ... on MediaImage {
                  image: thumbnail {
                    url
                  }
                }
              }
            }
            fieldTeaserMedia {
              entity {
                ... on MediaImage {
                  image: thumbnail {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
}

export { LayoutBox, fragments }
